import './index.less'

export default {
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    justify: String, // start end center space-around space-between
    aligner: String, // top middle bottom
    wrap: Boolean,
    column: Boolean,
  },
  render(h, ctx) {
    const { props } = ctx
    const prevName = 'f-row'
    ctx.data.staticClass = ctx.data.staticClass || ''

    ctx.data.staticClass += ` ${prevName}`

    if (props.justify) {
      ctx.data.staticClass += ` ${prevName}-${props.justify}`
    }

    if (props.aligner) {
      ctx.data.staticClass += ` ${prevName}-${props.aligner}`
    }

    if (props.wrap) {
      ctx.data.staticClass += ` ${prevName}-wrap`
    }
    if (props.column) {
      ctx.data.staticClass += ` ${prevName}-column`
    }

    return h(props.tag, ctx.data, ctx.children)
  },
}
